import axios from 'axios';
import { showNotification } from '../../Notifications/NotificationActions';
import {
    requestCaseSearch,
    successCaseSearch,
    failedCaseSearch,
    requestFileDownload,
    successFileDownload,
    failedFileDownload,
    requestCaseTrustness,
    successCaseTrustness,
    failedCaseTrustness,
    requestFileTrustness,
    successFileTrustness,
    failedFileTrustness,
    requestLookUp,
    successLookUp,
    failedLookUp,
    resetCase,
    completeFileTrustEvent,
} from './CaseReducer';
import { sec } from '../../../security';
import config from '../../../auth.config';
import { CASEVIEW_DATA_SUCCESS } from '../Dashboard/DashboardReducer';
import { ActionCreator, Dispatch } from 'redux';
import { ThunkAction } from 'redux-thunk';
import {
    IWorkspaceAction,
    IWorkspaceState,
} from '../../../common/model/WorkspaceModels';

const API_ROOT = process.env.REACT_APP_API_ROOT;

//= ========Thunks===========

export const getCase = (workspaceId, caseId) => async (dispatch) => {
    const access_token = await sec.getAccessTokenSilently()({
        audience: config.audience,
    });

    dispatch(requestCaseSearch(workspaceId, caseId));
    return axios({
        method: 'GET',
        url: `${API_ROOT}/case/${workspaceId}/${caseId}`,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Accept: 'application/json',
            Authorization: `Bearer ${access_token}`,
        },
    })
        .then((response) => {
            dispatch(successCaseSearch(workspaceId, caseId, response.data));
            return response.data;
        })
        .catch((error) => {
            dispatch(
                showNotification(
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        'Error loading case info.',
                    'error'
                )
            );
            dispatch(
                failedCaseSearch(
                    workspaceId,
                    caseId,
                    (error.response && error.response.data) || error
                )
            );
        });
};

export const lookUpCase = (workspaceId, startsWith) => {
    const thunk = async (dispatch, getState) => {
        const access_token = await sec.getAccessTokenSilently()({
            audience: config.audience,
        });

        dispatch(requestLookUp());
        return axios({
            method: 'GET',
            url: `${API_ROOT}/case/${workspaceId}/search`,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                Accept: 'application/json',
                Authorization: `Bearer ${access_token}`,
            },
            params: {
                limit: 10,
                q: startsWith,
            },
        })
            .then((response) => {
                const tableData = {
                    tableData: {
                        items: response.data,
                    },
                };
                dispatch(successLookUp(response.data));
                dispatch({
                    type: CASEVIEW_DATA_SUCCESS,
                    payload: tableData,
                    workspaceId,
                    loading: false,
                });
            })
            .catch((error) => {
                dispatch(
                    showNotification(
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                            'Error occurred while looking up the case. Please, try again later.',
                        'error'
                    )
                );
                console.log(error);
                dispatch(
                    failedLookUp(
                        (error.response && error.response.data) || error
                    )
                );
            });
    };

    thunk.meta = {
        debounce: {
            time: 500,
            key: 'search-case',
        },
    };
    return thunk;
};

export const checkCaseTrustness = (workspaceId, caseId) => async (dispatch) => {
    const access_token = await sec.getAccessTokenSilently()({
        audience: config.audience,
    });

    dispatch(requestCaseTrustness(workspaceId, caseId));
    return axios({
        method: 'POST',
        url: `${API_ROOT}/case/${workspaceId}/${caseId}/trust`,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Accept: 'application/json',
            Authorization: `Bearer ${access_token}`,
        },
    })
        .then((response) => {
            dispatch(successCaseTrustness(workspaceId, caseId, response.data));
        })
        .catch((error) => {
            // dispatch(
            //     showNotification(
            //         (error.response &&
            //             error.response.data &&
            //             error.response.data.message) ||
            //             'Error checking certification trustness',
            //         'error'
            //     )
            // );
            console.log(error);
            dispatch(
                failedCaseTrustness(
                    workspaceId,
                    caseId,
                    (error.response && error.response.data) || error
                )
            );
        });
};

export const getFile = (id, name) => async (dispatch) => {
    const access_token = await sec.getAccessTokenSilently()({
        audience: config.audience,
    });

    dispatch(requestFileDownload(id));
    return axios({
        method: 'GET',
        url: `${API_ROOT}/file/${id}`,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Accept: 'application/json',
            Authorization: `Bearer ${access_token}`,
        },
        responseType: 'blob',
    })
        .then((response) => {
            dispatch(successFileDownload(id, name, response.data));
        })
        .catch((error) => {
            dispatch(
                showNotification(
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        'Error downloading file',
                    'error'
                )
            );
            console.log(error);
            dispatch(
                failedFileDownload(
                    id,
                    (error.response && error.response.data) || error
                )
            );
        });
};

export const checkFileTrustness: ActionCreator<
    ThunkAction<Promise<any>, IWorkspaceState, null, IWorkspaceAction>
> = (fileIds: string[]) => async (dispatch: Dispatch) => {
    const access_token = await sec.getAccessTokenSilently()({
        audience: config.audience,
    });

    dispatch(requestFileTrustness(fileIds));
    return axios({
        url: `${API_ROOT}/file/trust`,
        data: fileIds,
        headers: {
            accept: '*',
            'content-type': 'application/json',
            Authorization: `Bearer ${access_token}`,
        },
        method: 'POST',
        onDownloadProgress: (progressEvent) => {
            const xhr = progressEvent.event.target;
            const { responseText } = xhr;
            // console.log('=====responseText======');
            // console.log(responseText);
            const resolvedData = responseText.split('\n');
            const files = {};
            // remove empty strings, combine values in 3 (not JSON parsable so doing hacky things)
            const output = resolvedData.filter(Boolean).reduce((a, str, i) => {
                if (i % 3 === 0) {
                    a.push(str + ',');
                } else {
                    a[a.length - 1] += str + ',';
                }
                return a;
            }, []);
            // get important information ie file ID and data
            // eslint-disable-next-line array-callback-return
            output.map((item: string, i: any) => {
                const parsedData = item
                    .split('data:')
                    .pop()
                    .split(',id:')
                    .shift();
                const fileId = item.split('event:').pop().replace(',', '');
                files[fileId] = {
                    trust: JSON.parse(parsedData),
                    checkingTrust: false,
                };
            });
            dispatch(successFileTrustness(files));
        },
    })
        .then(({ data }) => {
            Promise.resolve(data);
            console.log('=====File Trust SSE Resolved=====');
            dispatch(completeFileTrustEvent());
        })
        .catch((error) => {
            console.log('TRUST ERROR', error);
            dispatch(
                failedFileTrustness(
                    (error.response && error.response.data) || error
                )
            );
            dispatch(completeFileTrustEvent());
        });
};

export const resetSelectedCase = () => (dispatch) => {
    dispatch(resetCase());
};
